import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { CirclePlus, CircleMinus } from "lucide-react";
import Images from "../../Images";

const FAQ = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const toggleQuestion = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  const questions = [
    "How Do I Started on Dealboxx?",
    "What Kind of Deals I post on Dealboxx?",
    "How do I track the performance of my posted deals?",
    "Can I promote my deals on Dealboxx??",
    "Is there a limit to how many deals i can post??",
  ];

  const answers = [
    "To get started, simply sign up for an account on our platform. Once registered, you can begin posting your exclusive deals and manage them through your dashboard",
    "You can post various types of deals including discounts, promotional offers, limited-time sales, bundles, and special events. Customize your deal to attract customers with relevant offers.",
    "Our analytics dashboard provides real-time data on how your deals are performing. You can track metrics such as total views, redemptions, reach, and user engagement.",
    "Yes, Dealboxx offers options for promoting your deals. You can choose to advertise your deals to reach a larger audience and increase visibility.",
    "There is no strict limit on the number of deals you can post. However, different subscription plans may offer varying levels of access and management features.",
  ];

  return (
    <div className="bg-gradient-to-b from-[#FCF2F2] to-white py-16 md:py-24" id="faq">
      <div className="max-w-[1200px] mx-auto px-4 md:px-6 lg:px-8">
        <div className="flex flex-col gap-12 lg:flex-row lg:gap-20">
          {/* FAQ Content Section */}
          <div className="flex-1">
            <div className="mb-12">
              <h2 className="text-4xl font-bold leading-tight text-gray-900 md:text-5xl lg:text-6xl">
                Frequently Asked
                <span className="block text-red-600">Questions</span>
              </h2>
              <p className="mt-4 text-lg text-gray-600">
                Everything you need to know about using Dealboxx. Can't find the answer you're looking for? Feel free to contact our support team.
              </p>
            </div>

            <div className="space-y-4">
              {questions.map((question, index) => (
                <motion.div
                  key={index}
                  initial={{ opacity: 0, y: 20 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ delay: index * 0.1 }}
                  className="bg-white rounded-xl border border-gray-200 shadow-sm transition-all duration-300 hover:shadow-md"
                >
                  <button
                    onClick={() => toggleQuestion(index)}
                    className="flex gap-4 justify-between items-center px-6 py-5 w-full"
                    aria-expanded={openIndex === index}
                  >
                    <span className="font-semibold text-left text-gray-900">
                      {question}
                    </span>
                    <motion.div
                      animate={{ rotate: openIndex === index ? 45 : 0 }}
                      transition={{ duration: 0.2 }}
                    >
                      {openIndex === index ? (
                        <CircleMinus className="w-6 h-6 text-red-500" />
                      ) : (
                        <CirclePlus className="w-6 h-6 text-red-500" />
                      )}
                    </motion.div>
                  </button>

                  <AnimatePresence>
                    {openIndex === index && (
                      <motion.div
                        initial={{ height: 0, opacity: 0 }}
                        animate={{ height: "auto", opacity: 1 }}
                        exit={{ height: 0, opacity: 0 }}
                        transition={{ duration: 0.3, ease: "easeInOut" }}
                      >
                        <div className="px-6 pb-5 text-gray-600">
                          <div className="mb-4 h-px bg-gray-200" />
                          <p className="leading-relaxed">
                            {answers[index]}
                          </p>
                        </div>
                      </motion.div>
                    )}
                  </AnimatePresence>
                </motion.div>
              ))}
            </div>
          </div>

          {/* Image Section */}
          <div className="hidden lg:block lg:w-[40%]">
            <motion.div
              initial={{ opacity: 0, x: 20 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.5, delay: 0.2 }}
              className="sticky top-24"
            >
              <div className="relative">
                <div className="absolute inset-0 bg-gradient-to-r rounded-3xl transform -rotate-6 from-red-500/10 to-orange-500/10"></div>
                <img
                  src={Images.faq_img}
                  alt="FAQ Illustration"
                  className="object-cover relative w-full rounded-3xl shadow-xl"
                />
              </div>
            </motion.div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FAQ;
